import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DataModelState } from '../reducers/datamodel.reducer';

export const dataModelState: any = createFeatureSelector<DataModelState>('dataModel');

export const tableInfo = createSelector(dataModelState, (state: any) => {
  // console.log(state);
  // state.tableInfo;
});
export const fieldInfo = createSelector(dataModelState, (state: any) => state.fieldInfo);
export const lookUpTables = createSelector(dataModelState, (state: any) => {
  return state.lookUpTables;
});

export const dataModel = createSelector(dataModelState, (state: any) => state);
export const dataModelData = createSelector(dataModelState, (state: any) => {
  // console.log(state);
  return state.data;
});

export const allDataModelTables = createSelector(dataModelState, (state: any) => state.allDataModelTables);

export const dataModelSaveSuccess = createSelector(dataModelState, (state: any) => {
  return state.results;
});

export const dataModelSaveFailure = createSelector(dataModelState, (state: any) => {
  return state.error;
});

export const dataModelTableSaveSuccess = createSelector(dataModelState, (state: any) => {
  return state.tableResults;
});

export const dataModelTableSaveFailure = createSelector(dataModelState, (state: any) => {
  return state.tableError;
});

export const dataModelTreeSaveSuccess = createSelector(dataModelState, (state: any) => {
  return state.treeResults;
});

export const dataModelTreeSaveFailure = createSelector(dataModelState, (state: any) => {
  return state.treeError;
});
export const treeOrder = createSelector(dataModelState, (state: any) => state.treeOrder);

export const complexTypeTables = createSelector(dataModelState, (state: any) => state.complexTypeTables);
export const foreignKeyTbl = createSelector(dataModelState, (state: any) => state.foreignKeyTbl);
export const allTables = createSelector(dataModelState, (state: any) => state.allTables);
export const fKSaveSuccess = createSelector(dataModelState, (state: any) => state.fKSaveSuccess);
export const fKSaveFailure = createSelector(dataModelState, (state: any) => state.fKSaveFailure);
export const fkDelSuccess = createSelector(dataModelState, (state: any) => state.fkDelSuccess);
export const fkDelFailure = createSelector(dataModelState, (state: any) => state.fkDelFailure);
export const allForeignKeys = createSelector(dataModelState, (state: any) => state.allForeignKeys);
